class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;        
    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {      
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));    
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    //this.getSearchResults(searchTerm);    
    this.getBloomreachSearchResults(searchTerm);    
  }
  
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      //this.getSearchResults(searchTerm);
      this.getBloomreachSearchResults(searchTerm);    
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const types = ['product', 'collection', 'page', 'article'];
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${encodeURIComponent(types)}&${encodeURIComponent('resources[limit]')}=4&resources[options][fields]=title,product_type,tag,variants.title&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        //console.log('predictive_search response')
        //console.log(response)

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        //console.log('resultsMarkup')
        //console.log(resultsMarkup)

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });      
  }

  getBloomreachSearchResults(searchTerm, sessionParams) {

    function randomId() {
      return String(Math.floor(1e12 + Math.random() * 9e12));
    }

    function getCookie(key) {
      const cookies = document.cookie.split('; ');
      const cookie = cookies.find(c => c.startsWith(key + '='));
      return cookie ? cookie.split('=')[1] : null;
    }

    let _br_uid_2 = getCookie('_br_uid_2');

    if (_br_uid_2) {
      _br_uid_2 = decodeURIComponent(_br_uid_2);
    } else {
      _br_uid_2 = '';
    }


    //const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    
    const params = new URLSearchParams({
      account_id: '8258',
      auth_key: 'hdrkqdeih5uyrcu6',
      domain_key: 'amiri',
      request_id: randomId(),
      // _br_uid_2: 'uid=7797686432023:v=11.5:ts=1428617911187:hc=55',
      _br_uid_2: _br_uid_2,
      //ref_url: window.location.href,
      url: window.location.href,
      request_type: 'search',
      search_type: 'keyword',
      q: searchTerm,
      //fl: 'pid,title,brand,price,sale_price,thumb_image,url,description',
      fl: 'pid,url',
      rows: 4,
      start: 0,
    });

    //fetch(`http://core.dxpapi.com/api/v1/core/?${params}`)
    fetch(`http://core.dxpapi.com/api/v1/core/?${params}`)
    .then((res) => res.json())
    .then((result) => {
      console.log('bloomreach result')
      console.log(result)
      this.renderBloomreachSearchResults(result.response.docs, searchTerm, result.response.numFound)
      
    })
  }


  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  renderBloomreachSearchResults(hits, searchTerm, total) {
    let html = ``;
    html += `<h2 id="Products" class="predictive-search__heading">Products</h2>`;
    html += `<ul class="collection__grid predictive-search__products flex flex--wrap list-unstyled" role="listbox" aria-labelledby="Products">`;
    hits.forEach(hit => {
      html += `<li role="option" aria-selected="false"  class="grid__item"></li>`
    });
    html += `</ul>`;

    html += `
    <div class="predictive-search__footer content--floating flex">
      <a href="javascript:void(0)" class="btn--clear-search btn btn--tertiary text-center">Clear</a>
      <a class="btn--search btn btn--primary text-center" href="/search?q=${searchTerm}">VIEW ${total}</a>
    </div>
    `;

    this.predictiveSearchResults.innerHTML = html;
    this.setAttribute('results', true);

    //this.setLiveRegionResults();

    hits.forEach((hit, i) => {
      getProductCardHTMLByHandle(hit.url.split('/products/')[1], i)
    });

    this.open();

    function getProductCardHTMLByHandle(handle, position) {
      //console.log('handle', handle)
      let url = `${window.Shopify.routes.root}products/${handle}?view=productcard-predictive-search`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          if (responseText.indexOf('404 Not Found') == -1) {
            document.getElementsByClassName('predictive-search__products')[0].getElementsByClassName('grid__item')[position].innerHTML = html;
          } 
        });
    }
  }

  setLiveRegionResults() {    
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent.replace('Clear', ''));
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.predictiveSearchResults.style.display = 'block';
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    document.body.classList.add('modal--open');          
    if(this.querySelector('.btn--clear-search')){
      this.querySelector('.btn--clear-search').addEventListener('click', () => {this.close(true)});
    }    
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
    document.body.classList.remove('modal--open');      
  }          
}

customElements.define('predictive-search', PredictiveSearch);

//console.log('predictive search')